import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  healthKeyValueAll: [],
  healthKeyValue: {},
  selectedCategory: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "keyName",
  sortOrder: "asc",
};

const healthKeyValueSlice = createSlice({
  name: "healthKeyValue",
  initialState,
  reducers: {
    setHealthKeyValueAll: (state, action) => {
      state.healthKeyValueAll = action.payload;
    },
    setHealthKeyValue: (state, action) => {
      state.healthKeyValue = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
  },
});

export const {
  setHealthKeyValueAll,
  setHealthKeyValue,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
  setSelectedCategory,
} = healthKeyValueSlice.actions;

export default healthKeyValueSlice.reducer;